import { LocalizedData } from '../../domain/localized-data';

/* eslint-disable prefer-arrow/prefer-arrow-functions */

export function localizedDataMapper<T>(source: LocalizedData<T>): LocalizedData<T>;
export function localizedDataMapper<T, S>(source: LocalizedData<T>, mapper: (t: T) => S): LocalizedData<S>;
export function localizedDataMapper<T, S>(source: LocalizedData<T>, mapper?: (t: T) => S): LocalizedData<S | T> {
  if (!mapper) {
    return {
      en: source.en,
      ar: source.ar,
    };
  }

  return {
    en: mapper(source.en),
    ar: mapper(source.ar),
  };
}
